<template>
  <div class="wrap">
    <nav id="nav">
      <!-- <div class="logo">
                <a ><img src="https://benda-motor-resource.oss-cn-hangzhou.aliyuncs.com/website/assets/assets/logo_2.png" alt=""></a>
            </div> -->
      <ul class="nav" >

        <li class="nav-item" v-for="(item, index) in nume" :key="index" v-if="item.hidden == false&&item.path!=='/cart'" 
          :class="actio == item.path ? 'active' : ''" >
          <!-- <a @click.prevent="goPush(  item.path,  in8l=='zh'?item.meta.title:item.meta.titleEn, in8l!=='zh'?item.meta.title:item.meta.titleEn)" :id="`index${index}`" @mouseenter="asyncWidth(index,item.meta.title)" -->
          <a @click.prevent="goPusha(  item.path,  sxtitle(item) , fxtitle(item),item )" :id="`index${index}`" @mouseenter="asyncWidth(index,item.meta.title)" 
          style="display: flex; align-items: center;justify-content: center;">
            <!-- <div style="position: relative;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{in8l=='zh'? item.meta.title :item.meta.titleEn}}   <span v-if="item.name=='Public'&&sum>0"  class="topnum">{{ sum }}</span></div> -->
             <div style="position: relative;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ sxtitle(item)}}   <span v-if="item.name=='Public'&&sum>0"  class="topnum">{{ sum }}</span></div>
            <i v-if="item.alwaysShow == true&&item.path!=='/Sales'" class="el-icon-arrow-down el-icon--right"></i>
          </a>
      

          <!-- <el-collapse-transition v-if="item.alwaysShow == true&&item.path!=='/Sales'">
            <div class="subMenu" >
              <ul class="wrap cca">
                <li v-for="(e, i) in item.children" :key="i" v-if="e.hidden == false">
                  
                  <a @click.prevent="goPush(e.path, sxtitle(e) , fxtitle(e)  )"> {{sxtitle(e) }}</a></li>
              </ul>
            </div>
          </el-collapse-transition> -->

        </li>

          <div  class="cbbot"  style="padding: 0 20px;" v-if="chlist.length>0"> 
            <div style="display: flex;width: 90%; margin:  0 auto;">
               <div v-for="(e, i) in chlist" :key="i" v-if="e.hidden == false" style="margin-right: 20px;" >
               <a @click.prevent="goPush(e.path, sxtitle(e) , fxtitle(e)  )" :class="actio===e.path?'cvv':'cv'"> {{sxtitle(e) }}</a>
          </div>
            </div>
            <!-- <div class="subMenu" style="padding:  0 80px;" >
              <ul class="wrap cca">
                <li v-for="(e, i) in chlist" :key="i" v-if="e.hidden == false" :class="actio==e.path?'cvv':''" > 
                   
                  <a @click.prevent="goPush(e.path, sxtitle(e) , fxtitle(e)  )"> {{sxtitle(e) }}</a></li>
              </ul>
            </div> -->
          </div>

    
      </ul>
    </nav>
  </div>
</template>

<!-- <script src="https://cdn.bootcss.com/jquery/1.12.4/jquery.min.js"></script> -->
<script src="https://www.jq22.com/jquery/jquery-3.3.1.js"></script>

<script type="text/javascript">
import $ from "jquery"
import { noticetList } from "../api/api";
import Utils  from "../utils/uilt.js";
 $(function(){
        // $('ul.nav li.nav-item').hover(function(){
        //     $(this).children('div.subMenu').stop().slideToggle(600);
        // })
    })
export default {

  data() {
    return {
      actio:'/shop',
      nume:[],
      in8l:'zh',
      sum:0,
      totale:0,
      cbc:'none',
      chlist:[]
    }
  },
  
mounted() {
			var that = this;
			Utils.$on('demo', function(strMsg) {
				that.topnum();
			})
		},
  watch: {
    '$route': {
      handler (newVal, old) {
     
        this.sum=sessionStorage.getItem('noticeTotal')
        // console.log(123444444,this.sum);
        
      },
      immediate: true
    }
  },
  created(){
   
    // let bbc = sessionStorage.getItem('noticeTotal')
    // if(bbc!==undefined&&bbc!==null&&bbc>0){
    //   this.sum=bbc
    // }else{
    //   this.sum=0
    // }
   this.getNoticeList()
    let aa =sessionStorage.getItem('i18n')
    this.in8l=aa
    this.nume  = JSON.parse( sessionStorage.getItem('menu'))
   let a  = JSON.parse( sessionStorage.getItem('menu'))
        a.forEach((e,i)=> {


      

          if(e.hidden ==false){
            if(e.alwaysShow==true){
              if(e.path==sessionStorage.getItem('nameaC')&&e.path!=='/Sales'){
        this.chlist=e.children
        //  this.actio=url.replace(/\//g,'')
      }
    
        console.log(12312456,this.chlist);
              e.children.forEach(z=>{
                let ig = 0 
                if(z.hidden==true){
                  ig++
                }
                if(ig==e.children.length){
                  this.nume[i].alwaysShow=false
                }
              })
            }
          }
        });
        let bb =sessionStorage.getItem('namea')
    if(bb!==undefined&&bb!==null){
      this.actio=bb
    }else{
      // this.actio=this.nume[0].path
    }

    // console.log(123,this.nume);
    
  },

  methods:{
    cb(){
      this.cbc='block'
      console.log(123);
      
    },
    sxtitle(e){
      let a =''
       
      if(this.in8l=='zh'){
        a=e.meta.title
      }
    if(this.in8l=='en'){
      if(e.meta.titleEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.meta.titleEn)
     
        a=c.en
      }else{
        a=e.meta.titleEn
      }
      

      }
      if(this.in8l=='de'){
         if(e.meta.titleEn.indexOf(":") !== -1){
             let d =JSON.parse(e.meta.titleEn)
a=d.de
         } else{
        a=e.meta.titleEn
      } 
         
      
      }
      return a

    },
      fxtitle(e){
          let a =''
      if(this.in8l=='zh'){
       if(e.meta.titleEn.indexOf(":") !== -1){
        let c =JSON.parse(e.meta.titleEn)
     
        a=c.en
      }else{
        a=e.meta.titleEn
      }
      }else{
         a=e.meta.title
      }
    
         
      
    
      return a
      },
    topnum(){
      this.sum=sessionStorage.getItem('noticeTotal')
    },
    async getNoticeList () {
      let param = new URLSearchParams();
 
      const { data: res } = await noticetList(
        param,
        0,
        '',
        '',
        1,
        100,
        'desc',
        'id',
      );
      console.log('res', res)
      // this.noticeList = res.rows
      let num = 0
      res.summary.forEach(zz => {
        num = num + zz.sum
      })

      this.sum=num
      sessionStorage.setItem('noticeTotal', num)
    },
    asyncWidth(index,title){
      //e.pageX
      const aindex = document.getElementById(`index${index}`)
      console.log(aindex)

      var x = aindex.getBoundingClientRect().left;

      console.log(x)
      const el = document.querySelectorAll('.cca')
      let b = [ ]
      this.nume.forEach(e=>{
        if(e.alwaysShow==true){
          b.push(e)
        }
      })
      let cc =0
      b.forEach((e,i)=>{
        if(e.meta.title == title ){
          console.log(123,i);
          
          cc = i 
        }
      })
      console.log(b,cc);
      
      // el[cc].style.marginLeft = x + 20+'px'
      
    },
    goPush(url,name,namef){
  
      this.actio=url
      this.cb()
      sessionStorage.setItem('name',name)
      sessionStorage.setItem('namef',namef)
      sessionStorage.setItem('namea',url)
      console.log(name,namef,this.actio);
      
      this.$router.push(url)
    },
     goPusha(url, name,namef,item){
       this.actio=url
      if(item.hidden == false&&item.path!=='/Sales'&&item.alwaysShow!==undefined){
        this.chlist=item.children
         this.actio=url.replace(/\//g,'')
      }else{
      
         this.chlist=[]
      }
      
     
      this.cb()
      sessionStorage.setItem('name',name)
      sessionStorage.setItem('namef',namef)
      sessionStorage.setItem('namea',url)
      sessionStorage.setItem('nameaC',url)
      console.log(name,namef,url,this.actio,item.hidden);
      
      this.$router.push(url)
    },
    aaccc(e){
      console.log(123123123123,e);
      
    }
  },
}
</script>
<style scoped>
html,
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box
}

html,
body {
  min-height: 100%
}

body {
  font-family: Helvetica, Pingfang SC, Microsoft YaHei, STHeiti, Verdana, Arial, Tahoma, sans-serif;
  font-size: 14px;
  color: #333;
  background: #fff;
  position: relative
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal
}

ul,
ol {
  list-style: none
}

img {
  border: none;
  vertical-align: middle
}

a {
  color: #666;
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
}

a:visited {
  color: #666;
  text-decoration: none
}

a:hover {
  color: #666;
  text-decoration: none
}

a:active {
  color: #666;
  text-decoration: none
}

table {
  border-collapse: collapse;
  table-layout: fixed
}

input,
textarea {
  outline: none;
  border: none
}

textarea {
  resize: none;
  overflow: auto
}

.clearfix {
  zoom: 1
}
.cbbot{
position: absolute;left:0;top:80px;display: flex;font-size: 38px;
width: 100%;
background-color: #f9f9f9;
line-height: 35px;
height: 50px !important;
}
.clearfix:after {
  content: ".";
  width: 0;
  height: 0;
  visibility: hidden;
  display: block;
  clear: both;
  overflow: hidden
}

/* 本案例CSS*/
header {
  position: relative;
  z-index: 9999;
  border-bottom: 2px solid #fafafa;
  height: 80px;
  box-sizing: border-box;
}

.wrap {
  width: 1200px;
  /* margin: 0 auto; */
}

.cca {
  /* margin-left: 60px; */
}

#nav {
  display: flex;
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
  flex-wrap: wrap;
}

.logo {
  width: 230px;
  overflow: hidden;
}

.logo a {
  display: block;
}

.logo a img {
  max-width: 100%;
}

ul.nav {
  display: inline-flex;
  flex: 1;
}

li.nav-item {
  /* flex: 1; */
margin-right: 30px;

}

li.nav-item>a {
  display: block;
  text-align: center;
  line-height: 80px;
  font-size:18px;
  position: relative;
}

li.nav-item>a::before {
  display: none;
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  border-width: 0 10px 10px;
  border-style: solid;
  border-color: transparent transparent #409eff;
  position: absolute;
}

li.nav-item:hover>a,
li.nav-item.active>a {
  color: #409eff;
}

/* li.nav-item:hover>.subMenu {
  display: block;

} */

li.nav-item:hover>a::before,
li.nav-item.active>a::before {
  display: block;
}
.topnum{
  position: absolute;
  right: -30px;
  top: 5px;
 
  background-color: red;
  color: #fff;
  text-align: center;
  border-radius: 100px;
  font-size: 14px;
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.cvv{
  color: #409eff !important;
}

/* 二级菜单 */
.subMenu {

  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #fafafa;
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}

.subMenu>ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
}

.subMenu>ul>li>a {
  display: block;
  padding: 0 18px;
  text-align: center;
  line-height: 50px;
  color: #000;
}

.subMenu>ul>li>a:hover {
  color: #409eff
}
</style>